document.addEventListener('DOMContentLoaded', function () {
  // Set up a mutation observer to monitor changes to rebuy and variant dropdowns
  // eslint-disable-next-line no-undef
  const observer = new MutationObserver(function (event, observer) {
    event.forEach((mutation) => {
      if (mutation.attributeName === 'class' || mutation.target.className === 'product-variant-id') {
        const checkRebuyLoaded = document.getElementById('rebuy-widget-142444')
        if (checkRebuyLoaded) {
          checkPrice()
        }
      }
    })
  })
  const config = {
    subtree: true,
    childList: true,
    attributes: true,
    characterData: true
  }

  // Update the label text for variant dropdown
  function updateLabelText () {
    const currentWidth = window.innerWidth
    const variantDropdownLabel = document.querySelector('.product-form__input--dropdown label')
    if (variantDropdownLabel !== null) {
      if (currentWidth > 910) {
        variantDropdownLabel.textContent = 'Choose Tubing'
      } else {
        variantDropdownLabel.textContent = 'Tubing'
      }
    }
  }

  // Do it on load
  updateLabelText()

  // Initialize ResizeObserver
  // eslint-disable-next-line no-undef
  const resizeObserver = new ResizeObserver(entries => {
    for (const entry of entries) {
      if (entry) {
        updateLabelText()
      }
    }
  })

  // Observe main content body for width changes
  const mainBody = document.getElementById('MainContent')
  if (mainBody) {
    resizeObserver.observe(mainBody)
  }

  // Handle variant default dropdown value
  // Check if VariantSelects class is available
  if (typeof VariantSelects === 'undefined') {
    return
  }

  // Change the default variant value
  // eslint-disable-next-line no-undef
  VariantSelects.prototype.setDefaultVariantValue = function () {
    const select = this.querySelector('select.select__select')
    const options = Array.from(select.options)
    const targetOption = options.find(option => option.value === 'SlimLine™ tube')
    if (targetOption) {
      const updateValue = document.querySelector('input[type="hidden"][name="id"]')
      select.value = 'SlimLine™ tube'
      updateValue.value = '40407653187680'
      select.dispatchEvent(new Event('change'))
    }
  }

  // Set the value if the instance is available
  const variantSelectInstance = document.querySelector('variant-selects')
  if (variantSelectInstance) {
    variantSelectInstance.setDefaultVariantValue()
  }

  // Setup an observer to monitor the variant dropdown
  const variantDropdown = document.querySelector('[id*="sleepdoctor_sharma_lp_featured_product"]')
  if (variantDropdown) {
    observer.observe(variantDropdown, config)
  }

  // Update the option text for P10 Nasal CPAP Mask
  function updateOptionText () {
    const mask = document.getElementById('142444-select-0')
    if (mask) {
      mask.forEach(option => {
        if (option.textContent === 'Standard - Fit Pack - All Size Cushions Included (S/M/L)') {
          option.textContent = 'Standard - Fit Pack - S / M / L'
        } else if (option.textContent === 'For Her Fit Pack - All Size Cushions Included (XS/S/M)') {
          option.textContent = 'For Her - Fit Pack - XS / S / M'
        }
      })
    }
  }

  // Return a formatted price for calculations
  function convertToCents (price) {
    const priceString = price.toString().replace('$', '').replace(/,/g, '').trim()
    if (priceString.includes('.')) {
      let [dollars, cents] = priceString.split('.')
      cents = cents.padEnd(2, '0').substring(0, 2)
      return parseInt(dollars) * 100 + parseInt(cents)
    } else {
      return Math.round(parseFloat(priceString) * 100)
    }
  }
  // Return a formatted price for display
  function convertToText (price) {
    const dollars = price / 100
    const formattedPrice = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(dollars)

    return formattedPrice
  }
  // Handle price checks
  function checkPrice () {
    const currentVariant = document.querySelector('input[type="hidden"][name="id"]').value
    const rebuyAirFitToggle = document.querySelector('#rebuy-widget-142444 .rebuy-product-block.airfit-p10')
    const rebuyClimateLineAirToggle = document.querySelector('#rebuy-widget-142444 .rebuy-product-block.airtouch-f20')
    const rebuyAirFitPrice = convertToCents(document.querySelector('#rebuy-widget-142444 .rebuy-product-block.airfit-p10 .rebuy-money').textContent)
    const rebuyClimateLineAirPrice = convertToCents(document.querySelector('#rebuy-widget-142444 .rebuy-product-block.airtouch-f20 .rebuy-money').textContent)
    const currentPrice = document.querySelectorAll('#lp-featured-product .compare-price')
    const currentSalePrice = document.querySelectorAll('#lp-featured-product .sale-price')
    let basePrice = 135400
    let baseSalePrice = 100400

    if (currentVariant === '40407653187680') {
      basePrice = 135400
      baseSalePrice = 100400
    } else if (currentVariant === '39485299654752') {
      basePrice = 135400
      baseSalePrice = 104400
    }

    if (rebuyAirFitToggle.classList.contains('is-selected')) {
      basePrice += rebuyAirFitPrice
      baseSalePrice += rebuyAirFitPrice
    }

    if (rebuyClimateLineAirToggle.classList.contains('is-selected')) {
      basePrice += rebuyClimateLineAirPrice
      baseSalePrice += rebuyClimateLineAirPrice
    }

    currentPrice.forEach(price => {
      price.textContent = convertToText(basePrice)
    })
    currentSalePrice.forEach(price => {
      price.textContent = convertToText(baseSalePrice)
    })
  }

  // setup a function to handle the rebuy widget changes
  function updateAddToCartRebuy () {
    const rebuyProductBlock = document.querySelectorAll('#rebuy-widget-142444 .rebuy-product-block')
    rebuyProductBlock.forEach(block => {
      observer.observe(block, config)
    })
  }

  const rebuyElement = document.getElementById('rebuy-widget-142444')
  if (rebuyElement) {
    rebuyElement.classList.remove('hide-i')
    updateOptionText()
    updateAddToCartRebuy()
  }

  // Handle adding the rebuy items to cart with the primary button
  function updateAddToCartWithRebuy () {
    // Get the product blocks
    const rebuyProductBlock = document.querySelectorAll('#rebuy-widget-142444 .rebuy-product-block')
    // Initialize formData
    const formData = { items: [] }
    // Loop through each block and get the variantId and push to formData
    if (rebuyProductBlock.length > 0) {
      rebuyProductBlock.forEach(block => {
        if (block.classList.contains('is-selected')) {
          const url = block.querySelector('.rebuy-product-title').href
          const cleanUrl = url.replace(/&amp;/g, '&')
          const queryString = cleanUrl.split('?')[1]
          const params = new URLSearchParams(queryString)
          const productId = params.get('variant')

          formData.items.push({
            id: parseInt(productId),
            quantity: 1
          })
        }
      })
    }

    return formData
  }

  // Override the default addToCartButton functionality
  const addToCartButton = document.querySelector('.add-to-cart--buy-now')
  if (addToCartButton) {
    addToCartButton.addEventListener('click', function (e) {
      e.preventDefault()

      const formData = { items: [] }
      // Get the items that the user wants to update in the cart
      const rebuyFormData = updateAddToCartWithRebuy()
      // Add the rebuy items to the cart if they exist
      if (rebuyFormData.items.length > 0) {
        formData.items = rebuyFormData.items
      }
      // Add the original product selected to the cart
      const originalProduct = document.querySelector('input[type="hidden"][name="id"]')
      if (originalProduct) {
        formData.items.push({
          id: parseInt(originalProduct.value),
          quantity: 1
        })
      }
      if (rebuyElement) {
        // Clear the current cart so there's no repeated items if a user switches between products
        fetch(window.Shopify.routes.root + 'cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(response => {
            // Add the discount code to the cart
            const discountCode = document.querySelector('[name="discount"]').value
            const discountApplyUrl = 'discount/' + discountCode + '?v=' + Date.now() + '&redirect=/checkout/'
            fetch(window.Shopify.routes.root + discountApplyUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(response => {
              // Push the items to the cart
              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              })
                .then(response => {
                  return response.json()
                })
                .catch((error) => {
                  console.error('Error:', error)
                })
            })
          })
      } else if (originalProduct) {
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
          .then(response => {
            return response.json()
          })
          .catch((error) => {
            console.error('Error:', error)
          })
      } else {
        console.error('No rebuy items found')
      }
    })
  }
  // Handle the overlays for the SD text popup
  document.querySelectorAll('.text-with-popup-container .main-title').forEach(element => {
    element.addEventListener('click', function () {
      this.parentElement.querySelector('.overlay').style.display = 'block'
      this.parentElement.querySelector('.modal-container').style.display = 'block'
    })
  })
  document.querySelectorAll('.text-with-popup-container .modal-close svg, .text-with-popup-container .overlay').forEach(element => {
    element.addEventListener('click', function () {
      this.closest('.text-with-popup-container').querySelector('.overlay').style.display = 'none'
      this.closest('.text-with-popup-container').querySelector('.modal-container').style.display = 'none'
    })
  })

  // Handle collapsible content clicks
  document.querySelectorAll('.collapsible-content').forEach(collapsible => {
    collapsible.addEventListener('click', function () {
      this.querySelector('.collapsible-content_header').classList.toggle('is-open')
    })
  })
})
